import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { fetchPlot } from '../actions/plotAction';
import PlotTable from '../components/Plots/PlotTable';
import Layout from '../components/Layout/Layout';


const Plots = ( { plotInfo, loading, msg, isAuthenticated, fetchPlot }: any ) => {
    
    // To be implemented hard referesh as difference componnent
    
    useEffect( ( ) => { 

        console.log( 'inside plot effect ', plotInfo );
        if ( !plotInfo ) {

            fetchPlot( );

        }
        else {
            console.log( 'Already Fetched' );
        }

    }, [  ] );

    return (
        
        <Layout>
            <PlotWrapper>
                <div className="main-container">
                    <div className="header-container">
                        <div className="heading">
                            {/* <h2>Heading component</h2> */}
                        </div>
                        <div className="filters">
                            {/* <h2>Filter area</h2> */}
                        </div>
                    </div>
                    <div className="table-container">
                        {
                            loading ?
                            <h3>Loading component ... </h3>
                            :
                            <div>
                                {
                                    !plotInfo ?
                                    <h3>No Plot Available</h3>
                                    :
                                    <PlotTable plotInfo = { plotInfo } />
                                }
                            </div>
                        }
                    </div>
                </div>
            </PlotWrapper>
        </Layout>
    )
}

const mapStateToProps = ( state: any ) => ( { 

    isAuthenticated: state.admin.isAuthenticated,
    loading: state.plot.loading,
    msg: state.plot.msg,
    plotInfo: state.plot.plotInfo

} );

export default connect( mapStateToProps, {

    fetchPlot

} ) ( Plots );


const PlotWrapper = styled.div`


`;